import NAVBAR_MENU from "constant/menu";
import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { NavLink } from "react-router-dom";

const MenuMobile = ({ showMenuMobile, handleClose }) => {
  return (
    <div
      className={`fixed bg-white transition-all duration-300 z-50 w-full h-full
      ${showMenuMobile ? "opacity-100 top-0" : "opacity-0 -top-full"}`}
    >
      <div className="flex flex-col gap-6 items-center p-6">
        <div className="self-end cursor-pointer" onClick={handleClose}>
          <AiOutlineClose size={24} />
        </div>
        {NAVBAR_MENU.map((menu, idx) => {
          if (!menu?.show) {
            return null;
          }
          return (
            <NavLink
              key={idx}
              to={menu?.route}
              className={({ isActive }) =>
                isActive ? "text-wce-pink-dark" : "text-wce-neutral-8"
              }
              onClick={handleClose}
            >
              <span className="">{menu?.label}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default MenuMobile;
